module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAeUlEQVR4AWOgC3gro0IkopuG/xhg0s2tjZdX/P77B00cu4bTb2+rbMqUXJdw8OUVwhp+/v1ddG4+38pwnhWhQYc7f/z5RUDDvS8v0k5Nl1wbr745s+DsvLufXxDQ8OPv7xff37deXdN3Y9Off3+//P6OLDsY42FQAgDaox58oJN8JAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/LB.png
// module id = 1190
// module chunks = 0